import axios from "axios";

export const fetchRestrictedEmailDomains = async (): Promise<string> => {
  const { data } = await axios.get<string>(
    "https://dgk28ckagqims.cloudfront.net/mission-control/PageRegister/email_provider_domains.txt",
    {
      headers: {
        "Content-Type": "text/plain",
      },
    }
  );

  return data;
};

export type RegistrationCodeValidationStatus = "VALID" | "NOT_FOUND" | "EXPIRED";

interface RegistrationCodeValidationResponse {
  status: RegistrationCodeValidationStatus;
}

export const validateRegistrationCode = async (code: string): Promise<RegistrationCodeValidationResponse> => {
  const { data } = await axios.get<RegistrationCodeValidationResponse>("/registration-code/validate", {
    params: { code },
  });

  return data;
};
